<template>
  <Dropdown trigger="click" class="clickable" @on-click="handleOnChange">
    <Icon type="md-stats" style="transform:rotate(90deg)"/>
    {{ selectedItem }}
    <DropdownMenu slot="list">
      <DropdownItem name="Latest">Latest</DropdownItem>
      <DropdownItem name="Random">Random</DropdownItem>
      <DropdownItem name="Featured">Featured</DropdownItem>
      <DropdownItem name="A-Z">A-Z</DropdownItem>
      <DropdownItem name="Z-A">Z-A</DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
export default {
  data () {
    return {
      selectedItem: 'Latest'
    }
  },

  mounted () {
    if (this.$route.query && this.$route.query.sort_by) {
      this.selectedItem = this.$route.query.sort_by
      this.$emit('changed', this.$route.query.sort_by)
    }
  },

  methods: {
    handleOnChange (name) {
      if (this.$route.query) {
        this.$router.replace(
          {
            query: Object.assign({ ...this.$route.query }, { sort_by: name })
          },
          () => {}
        )
      }
      this.selectedItem = name
      this.$emit('changed', name)
    }
  }
}
</script>
